module.exports = __webpack_public_path__ + "static/media/homeicon.3e1953e4.svg";